import React from 'react';
import { GridView, ListView } from '@one-thd/sui-icons';
import { IconButton, Typography } from '@one-thd/sui-atomic-components';

interface ICardViewToggleProps {
  isListView: boolean;
  onChangeToggle: () => void;
}

export const CardViewToggle = ({
  isListView,
  onChangeToggle,
}: ICardViewToggleProps) => {
  return (
    <div className="sui-flex sui-gap-2 sui-justify-end sui-align-center">
      <div className="sui-flex sui-flex-col">
        <IconButton
          icon={GridView}
          aria-label="Grid view"
          data-testid="grid-view-button"
          iconSize="regular"
          color={!isListView ? 'brand' : 'primary'}
          onClick={() => {
            if (isListView) {
              onChangeToggle();
            }
          }}
        />
        <Typography variant="body-xs" align="center">
          Grid
        </Typography>
      </div>
      <div className="sui-flex sui-flex-col">
        <IconButton
          icon={ListView}
          aria-label="List view"
          data-testid="list-view-button"
          iconSize="regular"
          color={isListView ? 'brand' : 'primary'}
          onClick={() => {
            if (!isListView) {
              onChangeToggle();
            }
          }}
        />
        <Typography variant="body-xs" align="center">
          List
        </Typography>
      </div>
    </div>
  );
};
